import React from "react";
import { hero } from "../mock";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[92vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero.image}
          alt="Agence Loyaris à Paris"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#26241F]/60 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[92vh] max-w-[1320px] flex-col justify-center px-5 pt-24 lg:px-8">
        <p className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-white/25 bg-white/5 px-4 py-1.5 text-[12px] font-medium uppercase tracking-[0.18em] text-white/85 backdrop-blur-sm">
          {hero.eyebrow}
        </p>
        <h1 className="font-serifDisplay text-[52px] leading-[1.02] text-white sm:text-[68px] lg:text-[84px]">
          {hero.title}
        </h1>
        <p className="mt-6 max-w-xl text-[19px] font-semibold text-white">
          {hero.subtitle}
        </p>
        <p className="mt-3 max-w-xl text-[16px] leading-relaxed text-white/80">
          {hero.description}
        </p>

        <div className="mt-9 flex flex-wrap items-center gap-4">
          <a
            href="#contact"
            className="group flex items-center gap-2 rounded-md bg-[#B08D57] px-7 py-4 text-[15px] font-semibold text-[#26241F] transition-all hover:bg-[#c19d63] hover:shadow-lg"
          >
            {hero.primaryCta}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="/estimation-loyer"
            className="rounded-md border border-white/40 bg-white/5 px-7 py-4 text-[15px] font-semibold text-white backdrop-blur-sm transition-all hover:bg-white/15"
          >
            {hero.secondaryCta}
          </a>
        </div>
      </div>
    </section>
  );
}
